import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import VuexPersistence from 'vuex-persist'
import { commonStore } from '../components/common/store'
import { customerStore } from '../components/crm/store'
import { reportStore } from "../components/reports/store"
import { postStore } from "../components/content/store"
import { widgetStore } from "../../../custom-videos/resources/js/components/tools/store"
import { bannerStore } from "../components/campaigns/store"
import { campaignStore } from "../components/campaigns/store/campaignStore"
import { googleAdStore } from "../components/campaigns/store/googleAdStore"

Vue.use(Vuex)

const state ={
  application_module_groups: [],
  application_modules: [],
  user: {},
  appSettings: [],
  message: [],
  loading: false,
  pagination: {},
  onLogoutProgress: false,
  notifications: {},
  dashboard: {},
  token: null,
}

const controller = new AbortController();

const actions ={
  getApplicationModules({commit}, payload) {
    return new Promise((resolve, reject) => {
      axios.get('/api/application-modules', {
      }).then((response) => {
        commit('setApplicationModuleGroups', response.data.data.groups);
        commit('setApplicationModules', response.data.data.modules);
        resolve(response.data.data);
      }).catch((e) => {
        console.log('unable to get dashboard', e);
        reject(e);
      })
    })
  },
  login({commit}, data){
    return new Promise((resolve, reject) => {
      //get token first
      axios.post('/api/login', data).then((response) => {
        if(response.data) {
          commit('setOnLogoutProgress', false);
          commit('setToken', response.data.access_token);

          axios.get('/api/user').then((usr) => {
            commit('setUser', usr.data.data);
          });

          resolve(response);
        }else{
          resolve({});
        }

      }).catch((err) => {
        console.log('login err', err.message);
        reject(err);
      });
    })
  },
  getCurrentUser({commit}, payload) {
    return new Promise((resolve, reject) => {
      axios.get('/api/user').then((response) => {
        if(response.data && response.data.data) {
          resolve(response.data.data);
        } else {
          reject();
        }

      }).catch((e) => {
        reject(e);
      })
    })
  },
  logout({commit}){
    return new Promise((resolve, reject) => {
      axios.post('/api/logout').then((response) => {
        if(response.data){
          commit('setUser', null);
          commit('setOnLogoutProgress', true);
          commit('setToken', null);
          resolve(response.data);
        }
      }).catch((err) => {
        reject(err);
        commit('setOnLogoutProgress', false);
        console.log('logout error', err);
      });
    });
  },
  getAppSettings({commit}){
    axios.get('/api/app-settings', {
    }).then((response) => {
      if(response.data){
        commit('setAppSettings', response.data.data);
      }
    }).catch((err) => {
      console.log('an error occurred while getting app settings', err);
    });
  },
  getNotifications({commit}){
    axios.get('/api/notifications', {
    }).then((response) => {
      commit('setNotifications', response.data.data);
    }).catch((err) => {
      console.log('err on notifications', err);
    });
  },
  getDashboard({commit}, payload) {
    return new Promise((resolve, reject) => {
      commit('setLoadingStatus', true);
      axios.get('/api/dashboard', {
      }).then((response) => {
        commit('setDashboard', response.data.data);
        resolve(response.data.data);
        commit('setLoadingStatus', false);
      }).catch((e) => {
        console.log('unable to get dashboard', e);
        commit('setLoadingStatus', false);
        reject(e);
      })
    })
  },

}

const mutations ={
  setApplicationModules(state, payload) {
      state.application_modules = payload;
  },
  setApplicationModuleGroups(state, payload) {
    state.application_module_groups = payload;
  },
  setLoadingStatus(state, payload) {
    state.loading = payload;
  },
  setUser(state, user){
    state.user = user;
  },
  setAppSettings(state, settings){
    state.appSettings = settings;
  },
  setErrorMessage(state, message) {
    state.message = [];
    state.message.push({
      id: Math.ceil(Math.random()*10),
      color: 'bg-danger',
      message: message,
      top: 'top'
    });
  },
  setSuccessMessage(state, message) {
    state.message = [];
    state.message.push({
      id: Math.ceil(Math.random()*10),
      color: 'bg-success',
      message: message
    });
  },
  setInfoMessage(state, message) {
    state.message = [];
    state.message.push({
      id: Math.ceil(Math.random()*10),
      color: 'bg-primary',
      message: message
    });
  },
  clearMessage(state) {
    state.message = [];
  },
  setPagination(state, data) {
    state.pagination = data;
  },
  setOnLogoutProgress(state, data) {
    state.onLogoutProgress = data;
  },
  setNotifications(state, payload) {
    state.notifications = payload;
  },
  setDashboard(state, payload) {
    state.dashboard = payload;
  },
  setToken(state, payload) {
    state.token = payload;
  }
}

const getters ={
  token: state => state.token,
  loading: state => state.loading,
  applicationModuleGroups: state => state.application_module_groups,
  applicationModules: state => state.application_modules,
  user(state) {
    if(state.user !== undefined) {
      return state.user;
    }

    return {
      ID: '',
      first_name: '',
      last_name: '',
    }
  },
  userID(state) {
    if(state.user !== undefined) {
      return state.user.id;
    }
  },
  isAdmin(state) {
    if(state.user !== undefined) {
      return state.user.is_admin;
    }
  },
  appSettings: state => state.appSettings,
  getAppSettingsByCode(state){
    return code => {
      state.appSettings.filter( (item) => {
        return item.code === code
      });
    }
  },
  getMessage(state) {
    if(state.message) {
      return state.message;
    }
  },
  getPagination: state => state.pagination ? state.pagination : {},
  isLogoutProgress: state => state.onLogoutProgress,
  notifications: state => state.notifications,
  dashboard: state => state.dashboard,
}

const vuexLocal = new VuexPersistence({
  storage: window.localStorage
})

export default new Vuex.Store({
  modules: {
    commonStore,
    customerStore,
    reportStore,
    postStore,
    widgetStore,
    bannerStore,
    campaignStore,
    googleAdStore
  },
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
  plugins: [vuexLocal.plugin]
})
